import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/wxconfig/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/wxconfig/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/wxconfig/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/wxconfig/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/wxconfig/delete',
        method: 'post',
        data
    })
}

